<div class="alert-banner color-alert-{{ displayAlert.type }} text-center" *ngIf="displayAlert">
	<div class="row align-items-center">
		<div class="col-3">
			<div class="alert-numbers" [hidden]="alerts.length < 2">{{ alerts.length }}</div>
		</div>
		<div class="col-6">
			<div>
				<div
					class="alert-title"
					[ngClass]="{ active: displayAlert.message !== '' }"
					(click)="alertMessage(displayAlert)"
				>
					<span>{{ displayAlert.title }}</span>
				</div>
			</div>
		</div>
		<div class="col-3 text-right">
			<div class="button-wrap" (click)="alertMessage(displayAlert)" [hidden]="displayAlert.message === ''">
				<span class="material-icons icon">help_outline</span>
			</div>
			<div class="button-wrap" (click)="callback(displayAlert)" [hidden]="!displayAlert.callback">
				<span class="material-icons icon">local_hospital</span>
			</div>
			<div class="button-wrap" (click)="navigate(displayAlert)" [hidden]="!activateLink">
				<span class="material-icons icon">forward</span>
			</div>
			<div class="button-wrap" (click)="alertCancel(displayAlert)" [hidden]="!displayAlert.cancellable">
				<span class="material-icons icon">highlight_off</span>
			</div>
		</div>
	</div>
</div>
